var _desc, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgModicon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,2.8l-4,2.3L8,2.8l4-2.3L16,2.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.9,5.4v4.7l-4-2.3V3.1L11.9,5.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.3,3.1v4.7l-4,2.3V5.4L16.3,3.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.2,14.3l-4,2.3l-4-2.3l4-2.3L8.2,14.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.1,17v4.7l-4-2.3v-4.7L4.1,17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,14.7v4.7l-4,2.3V17L8.5,14.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.8,14.3l-4,2.3l-4-2.3l4-2.3L23.8,14.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.6,17v4.7l-4-2.3v-4.7L19.6,17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,14.7v4.7l-4,2.3V17L24,14.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,6.1L3.9,8.2C3.6,8.3,3.5,8.6,3.5,8.9v3.3l0.8-0.4L5,12.1V9.3l2.4-1.4L7.5,6.1L7.5,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1,8.2l-3.5-2V8L19,9.3v2.8l0.7-0.4l0.9,0.5V8.9C20.5,8.6,20.4,8.3,20.1,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,19.7L12,21.5l-3.1-1.8l0,0l-1.5,0.9l4.2,2.4c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1l4.4-2.5L15.2,19.7z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgModicon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/modicon.67f1cb69.svg";
export { ForwardRef as ReactComponent };